module.exports = __webpack_public_path__ + "static/media/ducks-unlimited.ae6b817a.png";